import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';

import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { BASE_PRODUCTS_PATH } from '../../../routes/constants';
import { SimpleModal } from '../../../components/simple-modal';

import { messages } from './messages';
import style from './style.module.less';

export const SetupProductAutoSplittingModal = ({ onClose }) => (
  <SimpleModal
    className={style['setup-product-auto-split-modal']}
    headerMessage={messages.setupAutoSplitModalHeader}
    onClose={onClose}
    size='custom'
  >
    <FlexColumn>
      <Text textType={TextType.Paragraph} value={messages.autoSplitModalIntroduction} />
      <ol>
        <li className={style['setup-product-auto-split-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.autoSplitModalInstruction1} />
        </li>
        <li className={style['setup-product-auto-split-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.autoSplitModalInstruction2} />
        </li>
        <li className={style['setup-product-auto-split-list-item']}>
          <Text textType={TextType.Paragraph} value={messages.autoSplitModalInstruction3} />
        </li>
      </ol>
      <Link to={BASE_PRODUCTS_PATH}>
        <FlexRow>
          <Text textType={TextType.Paragraph} value={messages.goToProductsLink} />
          <FontAwesomeIcon className={style.icon} icon={faArrowRight} />
        </FlexRow>
      </Link>
    </FlexColumn>
  </SimpleModal>
);

SetupProductAutoSplittingModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
